module.exports = __webpack_public_path__ + "img/Botswana.b62a5cde.svg";